<template>
	<div>
		<div class="pt-0 pl-3 pr-0 ml-0 ml-0 locum-view-card">
			<v-row no-gutters class="pb-3">
				<v-col>
					<v-card class="elevation-1 justify-center text-center" color="white">
						<v-row v-if="(!locumData && !locumFromStore.booking) || loading" justify="center">
							<v-col cols="1" class="mt-8 mb-8">
								<v-progress-circular indeterminate></v-progress-circular>
							</v-col>
						</v-row>
						<v-row v-if="showLocumSection && hasLocum && locumData && !loading">
							<v-col :cols="6" :lg="6">
								<v-row v-if="!locumPreviewId">
									<v-col>
										<div>
											<v-btn class="v-btn v-btn--text theme--light v-size--default secondary--text" style="float: left" text @click="cancelLocumSearch()"
												><v-icon left large color="secondary">mdi-chevron-left</v-icon>Back</v-btn
											>
										</div>
									</v-col>
								</v-row>

								<div>
									<v-hover>
										<v-list-item-avatar
											slot-scope="{ hover }"
											:class="{ 'elevation-10': hover }"
											:size="$vuetify.breakpoint.smAndDown ? 110 : 140"
											align="center"
											justify="center"
										>
											<v-skeleton-loader
												v-if="!locumImage"
												type="image"
												:loading="true"
												:width="$vuetify.breakpoint.smAndDown ? 110 : 140"
												:height="$vuetify.breakpoint.smAndDown ? 110 : 140"
												align="center"
												justify="center"
											>
											</v-skeleton-loader>
											<template v-if="locumImage">
												<v-img id="professional-avatar" :src="locumImage" @click="avatarModel = true"></v-img>
											</template>
										</v-list-item-avatar>
									</v-hover>
								</div>

								<v-container align="center" justify="center" class="pa-5 pb-0">
									<v-dialog v-model="avatarModel" width="500">
										<v-card>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn color="primary" text @click="avatarModel = false"> Close </v-btn>
											</v-card-actions>
											<v-container align="center" justify="center">
												<v-img :src="locumImage"></v-img>
											</v-container>
										</v-card>
									</v-dialog>
								</v-container>

								<div align="left" class="pl-2 mt-3">
									<div v-for="detail in locumLocationDetails" :key="detail.name">
										<small v-if="detail.name && detail.value" class="mt-1">
											<strong>{{ detail.name }}:</strong>
											{{ detail.value }}
										</small>
									</div>
								</div>

								<div class="black-text font-weight-black mt-4 pl-2" align="left">Short Bio</div>

								<div v-if="locum.short_bio" class="pr-1 text-left pl-2">
									<small>{{ locum.short_bio }}</small>
								</div>

								<div
									v-if="
										(viewSource !== 'locumDirectory' && viewSource === 'viewUpcomingBooking') ||
										(viewSource !== 'locumDirectory' && viewSource === 'viewBookingRequestSent')
									"
									class="pr-1 text-left pl-2"
								>
									<v-btn class="white--text button-rounded mt-2" :height="25" width="100%" color="green" @click="BookAgain()"
										><span style="font-size: 10px">Book Again</span></v-btn
									>
								</div>

								<div v-if="viewSource === 'quickBookOption'" class="mt-4 pl-1 pr-1" width="90%">
									<v-row>
										<v-col class="justify-center text-center">
											<v-btn-toggle v-model="calendarInputMode" mandatory>
												<v-btn
													rounded
													small
													:color="calendarInputMode == 0 ? 'primary' : '#FFF'"
													:class="[calendarInputMode == 0 ? 'white--text' : 'primary--text text--darken-2']"
													style="
														border-radius: 20px 0px 0px 20px;
														font-family: Montserrat;
														font-style: normal;
														font-weight: bold;
														font-size: 10px;
														line-height: 15px;
														text-align: center;
													"
												>
													Date range
												</v-btn>

												<v-btn
													rounded
													small
													:color="calendarInputMode == 1 ? 'primary' : '#FFF'"
													:class="[calendarInputMode == 1 ? 'white--text' : 'primary--text text--darken-2']"
													style="
														border-radius: 0px 20px 20px 0px;
														font-family: Montserrat;
														font-style: normal;
														font-weight: bold;
														font-size: 10px;
														line-height: 15px;
														text-align: center;
													"
												>
													Specific days
												</v-btn>
											</v-btn-toggle>
										</v-col>
									</v-row>
									<v-date-picker
										v-model="selectedDates"
										:min="new Date().toISOString().substr(0, 10)"
										header-color="primary"
										color="primary"
										full-width
										no-title
										:multiple="calendarInputMode == 1"
										:range="calendarInputMode == 0"
										class="elevation-0"
									></v-date-picker>

									<v-btn :class="[contrastOnPrimary, 'button-rounded', 'mt-2']" :height="25" width="80%" color="primary" @click="() => {}"
										><span style="font-size: 10px">Quick Book</span></v-btn
									>
								</div>
							</v-col>
							<v-col :cols="6" :lg="6" class="text-left">
								<div class="title black--text font-weight-black mt-2">{{ locum.first_name }} {{ locum.last_name }}</div>
								<div class="blue--text lighten-1 font-weight-black">{{ locum.profession }}</div>

								<div align="left" class="mt-3">
									<div v-for="detail in locumDetails" :key="detail.name">
										<small v-if="detail.name && detail.value" class="mt-1">
											<strong>{{ detail.name }}:</strong>
											{{ detail.value }}
										</small>
									</div>
								</div>

								<div v-if="locum.skills && locum.skills.length > 0" class="mt-3">
									<div class="black-text font-weight-black mt-4">{{ getLabel('additionalSkills', 'Skills & Courses') }}</div>
									<div v-for="code in locum.skills" :key="code" :v-if="industryKeys[code]">
										<small>{{ industryKeys[code] }}</small>
									</div>
								</div>

								<locum-work-experience
									v-if="
										locum.experience.companies_worked_for &&
										[
											'calendarDashboardSearchExact',
											'calendarDashboardSearchPartial',
											'viewLocumApplication',
											'viewUpcomingBooking',
											'viewBookingRequestSent',
											'viewPostedOffer',
											'viewHistoricalBooking',
											'locumDirectory',
											'previewLocumProfile',
										].includes(viewSource)
									"
									:companies="locum.experience.companies_worked_for"
									class="mt-4"
								></locum-work-experience>

								<div v-if="locumRates.length === 3" class="mt-3">
									<div class="black-text font-weight-black mt-4">Hourly Rates</div>
									<div v-for="rate in locumRates" :key="rate.label">
										<small>{{ rate.label }}: {{ rate.value }}</small>
									</div>
								</div>

								<div class="mt-5">
									<v-row align="center" justify="center">
										<v-col cols="12" sm="12" md="12">
											<v-btn
												v-if="viewSource.includes('calendarDashboardSearch')"
												class="white--text button-rounded mt-2"
												:height="25"
												width="80%"
												color="primary"
												@click="sendBookingRequest()"
												><span style="font-size: 10px">{{ getLabel('bookingFlowSendBookingRequest', 'Send Booking Request') }}</span></v-btn
											>
										</v-col>
									</v-row>
								</div>
							</v-col>
						</v-row>

						<hr v-if="showLocumSection && locumFromStore.booking" style="background: #f0f0f0; width: 85%; margin: auto; border: none; height: 2px" class="mt-4" />

						<v-row v-if="!showLocumSection">
							<v-col>
								<div>
									<v-btn class="v-btn v-btn--text theme--light v-size--default secondary--text" style="float: left" text @click="cancelLocumSearch()"
										><v-icon left large color="secondary">mdi-chevron-left</v-icon>Back</v-btn
									>
								</div>
							</v-col>
						</v-row>

						<div v-if="locumFromStore.booking" class="mt-4 pl-2">
							<div class="black-text font-weight-black" align="left">{{ hasLocum ? 'Booking' : 'Offer' }} Details:</div>
							<booking-details :booking="booking" />
						</div>

						<div v-if="locumFromStore.booking && viewSource !== 'viewPostedOffer'">
							<booking-cost-summary :locum="locumData" :booking="booking"></booking-cost-summary>
						</div>

						<v-row class="pb-3">
							<v-spacer />
							<v-col :cols="6" align="left" justify="left">
								<div v-if="viewSource === 'viewLocumApplication'">
									<v-btn
										style="position: relative"
										:class="[contrastOnAccent, 'button-rounded', 'mt-2']"
										:height="25"
										width="80%"
										color="accent"
										@click="openMessageDialog()"
									>
										<span style="font-size: 10px">Message</span>
										<v-badge
											class="badge-styling"
											:content="unreadMessageCount"
											:value="unreadMessageCount"
											color="primary"
											overlap
											top
											bordered
											offset-y="top"
											offset-x="right"
										></v-badge>
									</v-btn>
									<v-btn class="white--text button-rounded mt-2" :height="25" width="80%" color="#63C367" @click="doPracticeAcceptLocumApplication()"
										><span style="font-size: 10px">Accept Application</span></v-btn
									>
									<v-btn
										:class="[contrastOnPrimary, 'button-rounded', 'mt-2']"
										:height="25"
										width="80%"
										color="primary"
										@click="doPracticeDeclineLocumApplication()"
										><span style="font-size: 10px">Decline Application</span></v-btn
									>
								</div>
								<div v-if="['viewUpcomingBooking', 'viewBookingRequestSent'].includes(viewSource) && !isPastEvent" class="pr-2">
									<div v-if="!showCancel">
										<v-btn
											style="position: relative"
											class="white--text button-rounded mt-2"
											:height="25"
											width="100%"
											color="accent"
											@click="openMessageDialog()"
										>
											<span style="font-size: 10px">Message</span>
											<v-badge
												class="badge-styling"
												:content="unreadMessageCount"
												:value="unreadMessageCount"
												color="primary"
												overlap
												top
												bordered
												offset-y="top"
												offset-x="right"
											></v-badge>
										</v-btn>

										<v-btn
											v-if="['viewBookingRequestSent'].includes(viewSource)"
											class="white--text button-rounded mt-2"
											:height="25"
											width="100%"
											color="secondary"
											@click="editOffer()"
											><span style="font-size: 10px">Edit Booking {{ viewSource === 'viewBookingRequestSent' ? 'Request' : '' }}</span></v-btn
										>
										<v-btn class="white--text button-rounded mt-2" :height="25" width="100%" color="#f44336" @click="showCancel = true"
											><span style="font-size: 10px">Cancel Booking {{ viewSource === 'viewBookingRequestSent' ? 'Request' : '' }}</span></v-btn
										>
									</div>
									<div v-if="showCancel">
										<div>
											<p>
												<b>Cancellation Reason</b>
											</p>
											<v-textarea v-model="cancellationReason" style="font-size: 11px" auto-grow filled color="primary" rows="1"></v-textarea>
										</div>
										<v-btn
											class="white--text button-rounded"
											:height="25"
											color="primary"
											width="100%"
											:disabled="cancellationReason.length < 5"
											@click="cancelBooking"
											><span style="font-size: 10px">Submit Cancellation</span></v-btn
										>
										<v-btn class="white--text button-rounded mt-2" :height="25" color="#4d88a1 " width="100%" @click="showCancel = false"
											><span style="font-size: 10px">Nevermind</span></v-btn
										>
									</div>
								</div>
								<div v-if="viewSource === 'viewPostedOffer'">
									<v-btn :class="[contrastOnSecondary, 'button-rounded', 'mt-2']" :height="25" width="80%" color="secondary" @click="editOffer()"
										><span style="font-size: 10px">Edit this offer</span></v-btn
									>
									<v-btn class="white--text button-rounded mt-2" :height="25" width="80%" color="#f44336" @click="deletePublicOffer()"
										><span style="font-size: 10px">Cancel this offer</span></v-btn
									>
								</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</div>
		<PracticeEditBookingDialog ref="practiceEditBooking" :booking="booking" @bookigUpdate="updateBookingDetails"></PracticeEditBookingDialog>
	</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import store from '@/store';
import axios from 'axios';
import { bus } from '@/main';
import moment from 'moment';

import { Offer } from '@/models/offer.model';
import LocumWorkExperience from '@/components/custom/LocumWorkExperience.vue';
import BookingCostSummary from '@/components/custom/BookingCostSummary.vue';
import BookingDetails from '@/components/custom/BookingDetails.vue';
import PracticeEditBookingDialog from '@/components/ui/dashboard/practice/PracticeEditBookingDialog.vue';
import { resolveAssetImage } from '@/utils/util';

export default {
	name: 'ViewLocumDetailsCard',
	components: { LocumWorkExperience, BookingDetails, BookingCostSummary, PracticeEditBookingDialog },
	props: {
		locumPreviewId: String,
		source: String,
	},
	data: () => ({
		calendarInputMode: 0,
		range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
		selectedDatesSorted: [],
		person_outline_img: require('@/assets/images/rocket_man_transparent.webp'),
		locumImage: '',
		locumData: null,
		showCancel: false,
		cancellationReason: '',
		API_URL: store.getters.getAPI,
		industryKeys: store.getters.configs.industryKeys,
		avatarModel: false,
		loading: false,
		unreadMessageCount: 0,
	}),
	computed: {
		defaultAvatarImg() {
			return resolveAssetImage(this.tenant?.settings?.brandImages?.placeholders?.professional, this.person_outline_img);
		},
		computedMatchMin() {
			return Math.max(50, this.PercentageMatch());
		},
		showLocumSection() {
			return this.viewSource !== 'viewPostedOffer' && this.hasLocum;
		},
		hasLocum() {
			return this.locumFromStore.id || this.locumPreviewId;
		},
		locumExperience() {
			if (!this.locum.experience) {
				return 0;
			}
			const experienceYears = moment().diff(moment(this.locum.experience.start_date), 'years');
			const experienceSuffix = experienceYears === 1 ? ' year' : ' years';
			return experienceYears + experienceSuffix;
		},
		selectedDates: {
			get: function () {
				return this.selectedDatesSorted;
			},
			set: function (newValue) {
				this.selectedDatesSorted = newValue.sort((a, b) => moment(a).diff(b, 'days'));
			},
		},
		locumDetails() {
			const { qualifications = {}, indemnity_insurance } = this.locum;
			const defaultText = 'Not specified';
			const displayValue = value => {
				if (!value) return defaultText;
				if (String(value).trim().toUpperCase() === 'NA') return 'NA';
				return value;
			};
			const displayDate = value => {
				if (!value || String(value).trim().toUpperCase() === 'NA') return displayValue(value);
				const parsed = moment(value);
				return parsed.isValid() ? parsed.format('DD/MM/YYYY') : displayValue(value);
			};
			const data = [
				{
					name: 'Qualifications',
					value: displayValue(qualifications.qualification),
				},
				{
					name: this.getLabel('educationSectionCollege', 'Institution'),
					value: displayValue(qualifications.institution),
				},
				{
					name: this.getLabel('educationSectionDateQualified', 'Date Qualified'),
					value: displayDate(qualifications.year_qualified),
				},
				{
					name: 'Experience',
					value: this.locumExperience,
				},
				{
					name: 'Additional Qualifications',
					value: qualifications.other_qualifications,
				},
				{
					name: this.getLabel('driversLicence', 'Professional Indemnity'),
					value: indemnity_insurance?.has_indemnity_insurance ? 'Yes' : 'No',
				},
				// {
				// 	name: 'Indemnity Expiry',
				// 	value: indemnity_insurance?.indemnity_insurance_expiry ? moment(indemnity_insurance.indemnity_insurance_expiry).format('DD/MM/YYYY') : defaultText,
				// },
			];

			return data;
		},
		locumLocationDetails() {
			const { languages = [], address, willing_to_travel } = this.locum;
			const region = address?.region || 'Unknown';
			const data = [
				{
					name: 'Languages',
					value: languages.join(', '),
				},
				{
					name: 'Locations',
					value: region,
				},
			];
			if (willing_to_travel) {
				data.push({
					name: 'Willing to travel',
					value: 'Yes',
				});
			}
			return data;
		},
		company() {
			return store.getters.company;
		},
		locum() {
			return this.locumData;
		},
		locumFromStore() {
			return this.locumPreviewId ? this.locumPreviewId : store.getters.getPracticeViewingLocum[0];
		},
		locumId() {
			return this.locumPreviewId ? this.locumPreviewId : this.locumFromStore.id;
		},
		booking() {
			return this.locumFromStore.booking;
		},
		viewSource() {
			return this.source || this.locumFromStore.source || [];
		},
		locumRates() {
			if (!this.locum.working_hours) {
				return [];
			}
			const { weekdays, saturday, public_holidays } = this.locum.working_hours;

			return this.locum.working_hours
				? [
						{ label: 'Weekdays', value: this.formatLocumRate(weekdays) },
						{ label: 'Saturdays', value: this.formatLocumRate(saturday) },
						{ label: 'Sundays/Holidays', value: this.formatLocumRate(public_holidays) },
				  ]
				: [];
		},
		authToken() {
			return store.getters.jwtToken;
		},
		isPrivate() {
			const practiceOfferSelected = store.getters.getPracticeOfferSelected;
			const privateOfferType = Offer.TYPES.PRIVATE;
			return practiceOfferSelected.offer_type === privateOfferType || practiceOfferSelected?.offer?.offer_type === privateOfferType;
		},
		isPastEvent() {
			const { request_dates } = this.booking;
			if (request_dates && request_dates.length > 0) {
				const endDate = request_dates[request_dates.length - 1].date;
				return moment(endDate).isBefore(moment().startOf('day'));
			} else if (this.booking.booking_dates) {
				const endDate = this.booking.booking_dates[this.booking.booking_dates.length - 1];
				return moment(endDate).isBefore(moment().startOf('day'));
			} else {
				return false;
			}
		},
	},
	watch: {
		locumPreviewId() {
			this.initData();
		},
		locumFromStore() {
			this.initData();
		},
	},
	async mounted() {
		this.initData();
		await this.getUnreadMessageCount();
	},
	methods: {
		...mapMutations('offers', ['UPDATE_OFFERS']),

		...mapActions('offers', ['UpsertOffer']),

		...mapActions('message', ['GetConversationUnreadCount']),

		initData() {
			this.locumImage = null;
			this.locumData = null;
			if (this.hasLocum) {
				if (this.viewSource !== 'viewPostedOffer') {
					this.loading = true;
				}
				this.fetchLocumData();
			}
		},

		async fetchLocumData() {
			this.locumImage = this.locumFromStore.avatar;
			if (!this.locumImage) {
				axios
					.get(store.getters.getDOCUMENTS + '/images/avatar/' + this.locumId, this.requestHeader)
					.then(response => {
						this.locumImage = 'data:image/png;base64,' + response.data.data;
					})
					.catch(() => {
						this.locumImage = this.defaultAvatarImg;
					});
			}
			if (!this.locumData) {
				const locumGet = await axios.get(`${this.API_URL}/professionals/${this.locumId}`, this.requestHeader);
				this.locumData = locumGet.data.data;
			}
			this.loading = false;
		},
		cancelLocumSearch(locumData) {
			const contextOptions = {
				calendarDashboardSearchExact: 'practice-locum-search-results',
				calendarDashboardSearchPartial: 'practice-locum-search-results',
				viewLocumApplication: 'practice-dashboard-landing-zone',
				viewUpcomingBooking: 'practice-dashboard-landing-zone',
				viewBookingRequestSent: 'practice-dashboard-landing-zone',
				viewPostedOffer: 'practice-dashboard-landing-zone',
				viewHistoricalBooking: 'practice-dashboard-landing-zone',
			};
			if (this.viewSource === 'viewLocumApplication') {
				bus.$emit('refreshRequestsReceived');
				bus.$emit('UpdateCalendar');
			}
			if (locumData !== undefined) {
				bus.$emit('change-context', contextOptions[this.viewSource], locumData);
			} else {
				bus.$emit('change-context', contextOptions[this.viewSource]);
			}
		},
		formatLocumRate(day) {
			return day && day.rate ? `R${day.rate}` : 'Not specified';
		},
		requestHeader() {
			return { headers: { Authorization: this.authToken } };
		},
		async doPracticeAcceptLocumApplication() {
			const { id } = this.locumFromStore;

			const body = {
				id,
				status_reason: '-',
			};

			let requests = [];
			requests.push(axios.put(this.API_URL + '/offers/company/confirm-offer/' + this.booking.id, body, this.requestHeader));

			axios
				.all(requests)
				.then(() => {
					setTimeout(() => {
						bus.$emit('UpdateCalendar');
					}, 1000);
					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(err => {
					console.error('error on book offer', err);
				});
		},
		async doPracticeDeclineLocumApplication() {
			const { id } = this.locumFromStore;

			const body = {
				id,
				status_reason: "We noticed that you don't meet the necessary requirements.",
			};

			let requests = [];
			requests.push(axios.put(this.API_URL + '/offers/company/reject-offer/' + this.booking.id, body, this.requestHeader));

			axios
				.all(requests)
				.then(() => {
					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(err => {
					console.error('error on book offer', err);
				});
		},
		sendBookingRequest() {
			if (this.viewSource === 'calendarDashboardSearchExact') {
				store.dispatch('setPracticeViewingLocum', [{ ...this.locumData, ...this.locumFromStore }]);
			}
			bus.$emit('change-context', 'practice-to-locum-create-booking-request');
		},
		cancelBooking() {
			if (this.viewSource === 'viewUpcomingBooking') {
				this.doSubmitUpcomingBookingCancellation();
			}
			if (this.viewSource === 'viewBookingRequestSent') {
				if (!this.isPrivate) {
					this.doPracticeCancelPublicBookingRequest();
				} else {
					this.doPracticeCancelPrivateBookingRequest();
				}
			}
		},
		async doSubmitUpcomingBookingCancellation() {
			const body = {
				status_reason: this.cancellationReason,
			};

			await axios.put(this.API_URL + '/bookings/schedule/' + this.booking.id + '/' + this.booking.accountid + '/cancel', body, this.requestHeader);
			setTimeout(() => {
				bus.$emit('UpdateCalendar');
			}, 1000);
			bus.$emit('change-context', 'practice-dashboard-landing-zone');
		},
		async doPracticeCancelPrivateBookingRequest() {
			const body = {
				status_reason: this.cancellationReason,
			};

			await axios
				.put(this.API_URL + '/offers/company/private/cancel-offer/' + this.booking.id, body, this.requestHeader)
				.then(response => {
					this.UPDATE_OFFERS(response.data.data);
				})
				.then(() => {
					store.commit('PUSH_NOTIFICATION', { component: 'practice-request-cancelled', data: [''] });
					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('ERROR cancelling private booking request', error);
				})
				.finally(() => {
					setTimeout(() => {
						bus.$emit('UpdateCalendar');
					}, 1000);
				});
		},
		async doPracticeCancelPublicBookingRequest() {
			const body = {
				id: this.booking.id,
				status_reason: this.cancellationReason,
			};

			await axios
				.put(this.API_URL + '/calendar/professional/availability/cancel-booking-request/' + this.booking.availabilityId + '/' + this.booking.date, body, this.requestHeader)
				.then(async response => {
					store.dispatch('UPDATE_AVAILABILITY', response.data.data);
				})
				.then(async () => {
					store.commit('PUSH_NOTIFICATION', { component: 'practice-request-cancelled', data: [''] });
					await this.createPublicOffer();
					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('ERROR cancelling public booking', error);
				})
				.finally(() => {
					setTimeout(() => {
						bus.$emit('UpdateCalendar');
					}, 1000);
				});
		},
		async createPublicOffer() {
			const { start_time, end_time, date, booking_dates, notes, lunch, rates, skills } = this.booking;
			const {
				id,
				name,
				contact,
				email,
				industry,
				address: { unit_no, building_name, country, postal_code, province, region, street, suburb },
			} = this.company;
			const { profession, languages, experience, id: locumId, first_name, last_name, contact: locumContact, email: locumEmail, qualifications, working_hours } = this.locum;

			const sortedDates = booking_dates.sort((a, b) => moment(a).diff(moment(b)));

			const payload = {
				start_time,
				end_time,
				date,
				end_date: booking_dates[booking_dates.length - 1],
				company: {
					id,
					name,
					contact,
					email,
					industry,
					address: {
						unit_no,
						building_name,
						country,
						postal_code,
						province,
						region,
						street,
						suburb,
					},
				},
				notes,
				profession,
				experience: this.getYearsExperience(),
				languages,
				lunch,
				skills,
				available_dates: sortedDates,
				rates,
				offers_requests: [
					{
						id: locumId,
						name: first_name,
						surname: last_name,
						contact: locumContact,
						profession: profession,
						email: locumEmail,
						qualifications: {
							qualification: qualifications?.qualification,
							institution: qualifications?.institution,
							year_qualified: moment(qualifications?.year_qualified).format('YYYY'),
						},
						rates: {
							weekdays: 'R' + working_hours?.weekdays?.rate,
							saturday: 'R' + working_hours?.saturday?.rate,
							sundays: 'R' + working_hours?.sundays?.rate,
							public_holidays: 'R' + working_hours?.public_holidays?.rate,
						},
						status: 'cancelled',
						status_reason: 'Thank you for your booking request but I am no longer available for this slot',
						experience: moment(experience?.start_date)?.format('YYYY-MM-DD'),
						booking_dates: sortedDates,
					},
				],
			};

			try {
				await this.UpsertOffer(payload);
			} catch (err) {
				console.error('Failed to create private offer', err);
			}
		},
		getYearsExperience() {
			return 'experience' in this.locum ? moment().diff(this.locum.experience.start_date, 'years') : 0;
		},
		async deletePublicOffer() {
			const offer = this.booking;

			await axios
				.put(
					this.API_URL + '/offers/company/cancel-offer/' + offer.id,
					{
						status_reason: '-practice cancelled offer-',
					},
					this.requestHeader
				)
				.then(() => {
					bus.$emit('UpdateCalendar');
					// store.commit('DELETE_OFFER', offer);
					store.commit('PUSH_NOTIFICATION', { component: 'practice-offer-deleted', data: [''] });
					store.commit('POP_CHANNEL_NOTIFICATION', { channel: 'OffersPosted', identity: offer.id });

					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('Error deleting public offer ', error);
				});
		},
		editOffer() {
			this.$refs.practiceEditBooking.open();
		},
		updateBookingDetails(updatedOffer) {
			this.booking.request_dates = updatedOffer.request_dates;
			this.booking.start_time = updatedOffer.start_time;
			this.booking.end_time = updatedOffer.end_time;
			this.booking.lunch = updatedOffer.lunch;
			this.booking.rates = updatedOffer.rates;
			this.booking.booking_dates = updatedOffer.available_dates;
			this.booking.notes = updatedOffer.notes;
			setTimeout(() => {
				bus.$emit('UpdateCalendar');
			}, 1000);
		},
		async openMessageDialog() {
			const sentByID = this.company.id;
			let receiverDetails = {
				id: this.locum.id,
				name: this.locum.first_name,
			};
			bus.$emit('show-message-dialog', receiverDetails, sentByID);
			this.unreadMessageCount = 0;
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetConversationUnreadCount({
				receivedByID: this.company.id,
				sentByID: this.locumId,
			});
			this.unreadMessageCount = unreadCount;
		},

		async BookAgain() {
			this.cancelLocumSearch(this.locum);
		},
	},
};
</script>

<style scoped>
#professional-avatar {
	cursor: pointer;
}

.badge-styling {
	position: absolute;
	right: 0.5rem;
	top: -1rem;
}
</style>
